import { render, staticRenderFns } from "./create-type-select.vue?vue&type=template&id=53cc5df8&"
import script from "./create-type-select.vue?vue&type=script&lang=js&"
export * from "./create-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports